<template>
    <div class="iframe-box">
        <div class="zhegai"></div>
        <iframe id="iframe1" :style="'height:' + resizeHeight" :src="iframeSrc" frameborder="0"></iframe>
    </div>
</template>
<script>
export default {
    data() {
        return {
            iframeSrc: '',
            resizeHeight: '653',
            activeName: '1'
        };
    },
    mounted() {
        this.getDashboard();
        this.resizeHeight = window.innerHeight - 10 - 20 - 25 + 'px';
        window.onresize = () => {
            this.resizeHeight = window.innerHeight - 10 - 20 - 25 + 'px';
        };
    },
    methods: {
        handleClick() {},
        getDashboard() {
            this.instance.get('/ubi/api/case/dashboard/evcardSmsPlugin', { params: {} }).then((res) => {
                if (res.code == 200) {
                    let newLink = data.data;
                    newLink = newLink.replace(/bordered=true/g, 'bordered=false');
                    this.iframeSrc = newLink.replace(/titled=true/g, 'titled=false');
                }
            });
        }
    }
};
</script>
<style lang="less" scoped>
.iframe-box {
    width: 100%;
    height: 100% !important;
    overflow: hidden;
    position: relative;
    background: #fff;
    .chart_tabs {
        padding: 0 10px;
    }
}

#iframe1,
#iframe2 {
    width: 100%;
    height: 780px;
    padding-bottom: 33px;
}
.height_653 {
    height: 653px;
}
.zhegai {
    height: 20px;
    position: absolute;
    bottom: 0;
    width: 100%;
    background: #fff;
}
</style>